/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Watch_HintInputs */

const th_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จะยังไม่มีภาพจนกว่าจะมีคนถ่ายทอดสดเกมนี้`)
};

const en_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing appears until somebody is broadcasting this game.`)
};

const ja_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`誰かがこの試合を配信するまで何も表示されません。`)
};

const zh_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在有人直播这场比赛之前，不会显示任何内容。`)
};

const es_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No aparece nada hasta que alguien retransmita este partido.`)
};

const pt_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada aparece até alguém transmitir este jogo.`)
};

const id_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada yang muncul sampai seseorang menyiarkan pertandingan ini.`)
};

const fr_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rien n’apparaît tant que personne ne diffuse ce match.`)
};

const tl_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang lilitaw hangga't walang nagsasahimpapawid ng larong ito.`)
};

const vi_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sẽ không có gì hiện ra cho tới khi ai đó phát trận này.`)
};

const ko_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`누군가 이 경기를 중계하기 전까지는 아무것도 나타나지 않습니다.`)
};

const de_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es erscheint nichts, bis jemand dieses Spiel überträgt.`)
};

const ru_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ничего не появится, пока кто-нибудь не начнёт транслировать этот матч.`)
};

const tr_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biri bu maçı yayınlayana kadar hiçbir şey görünmez.`)
};

const it_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non comparirà nulla finché qualcuno non trasmetterà questa partita.`)
};

const pl_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nic się nie pojawi, dopóki ktoś nie zacznie transmitować tego meczu.`)
};

const uk_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нічого не з'явиться, поки хтось не почне транслювати цей матч.`)
};

const hi_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जब तक कोई इस मैच को प्रसारित न करे, कुछ नहीं दिखेगा।`)
};

const ar_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لن يظهر شيء حتى يبثّ أحد هذه المباراة.`)
};

const ms_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada apa akan muncul sehingga seseorang menyiarkan perlawanan ini.`)
};

const bn_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কেউ এই খেলা সম্প্রচার না করা পর্যন্ত কিছুই দেখা যাবে না।`)
};

const zh_tw2_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在有人轉播這場比賽之前，不會顯示任何內容。`)
};

const zh_hk2_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在有人轉播這場比賽之前，不會顯示任何內容。`)
};

const ur_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جب تک کوئی یہ میچ نشر نہ کرے، کچھ نہیں دکھے گا۔`)
};

const fa_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تا کسی این بازی را پخش نکند چیزی دیده نمی‌شود.`)
};

const sw_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna kitakachoonekana hadi mtu arushe mchezo huu.`)
};

const nl_video_watch_hint = /** @type {(inputs: Video_Watch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er verschijnt niets tot iemand deze wedstrijd uitzendt.`)
};

/**
* | output |
* | --- |
* | "Nothing appears until somebody is broadcasting this game." |
*
* @param {Video_Watch_HintInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_watch_hint = /** @type {((inputs?: Video_Watch_HintInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Watch_HintInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_watch_hint(inputs)
	if (locale === "ja") return ja_video_watch_hint(inputs)
	if (locale === "zh") return zh_video_watch_hint(inputs)
	if (locale === "es") return es_video_watch_hint(inputs)
	if (locale === "pt") return pt_video_watch_hint(inputs)
	if (locale === "id") return id_video_watch_hint(inputs)
	if (locale === "fr") return fr_video_watch_hint(inputs)
	if (locale === "tl") return tl_video_watch_hint(inputs)
	if (locale === "vi") return vi_video_watch_hint(inputs)
	if (locale === "ko") return ko_video_watch_hint(inputs)
	if (locale === "de") return de_video_watch_hint(inputs)
	if (locale === "ru") return ru_video_watch_hint(inputs)
	if (locale === "tr") return tr_video_watch_hint(inputs)
	if (locale === "it") return it_video_watch_hint(inputs)
	if (locale === "pl") return pl_video_watch_hint(inputs)
	if (locale === "uk") return uk_video_watch_hint(inputs)
	if (locale === "hi") return hi_video_watch_hint(inputs)
	if (locale === "ar") return ar_video_watch_hint(inputs)
	if (locale === "ms") return ms_video_watch_hint(inputs)
	if (locale === "bn") return bn_video_watch_hint(inputs)
	if (locale === "zh-TW") return zh_tw2_video_watch_hint(inputs)
	if (locale === "zh-HK") return zh_hk2_video_watch_hint(inputs)
	if (locale === "ur") return ur_video_watch_hint(inputs)
	if (locale === "fa") return fa_video_watch_hint(inputs)
	if (locale === "sw") return sw_video_watch_hint(inputs)
	if (locale === "nl") return nl_video_watch_hint(inputs)
	return en_video_watch_hint(inputs)
});